import { useExamEventDetails, ExamEventProctorDataGrid } from '@exam-center/exam-event-management';

import { columns } from './columns';

const proctorTypeMap = {
  PROCTOR_1: 'ผู้คุมสอบประเภทที่ 1',
  PROCTOR_2: 'ผู้คุมสอบประเภทที่ 2',
  PROCTOR_3: 'ผู้คุมสอบประเภทที่ 3',
  OBSERVER: 'ผู้สังเกตการณ์',
};

export default function ProctorList() {
  const { examEvent } = useExamEventDetails();

  const { proctors } = examEvent;

  const proctorRows = proctors?.map((proctor) => ({
    id: proctor.id,
    name: [proctor.titleTh, proctor.firstNameTh, proctor.middleNameTh, proctor.lastNameTh]
      .filter(Boolean)
      .join(' '),
    type: proctorTypeMap[proctor.type],
  }));

  return <ExamEventProctorDataGrid rows={proctorRows ?? []} columns={columns} />;
}
